import { useState } from "react";
import { Option } from "../../types/common";
import { listingSearchURL } from "./index";

interface ListingSearchState {
  keywords?: string;
  minPrice?: string;
  maxPrice?: string;
  selectedSuburbs?: string[];
  selectedCategories?: Option[];
  locationState?: Option;
  selectedRegions?: Option[];
  newListing?: boolean;
  status?: string;
}

export const useListingSearch = (initial: ListingSearchState = {}) => {
  const [loading, setLoading] = useState(false);
  const [selectedSuburbs, setSelectedSuburbs] = useState(
    initial.selectedSuburbs,
  );
  const [selectedCategories, setSelectedCategories] = useState(
    initial.selectedCategories,
  );
  const [keywords, setKeywords] = useState(initial.keywords);
  const [minPrice, setMinPrice] = useState(initial.minPrice);
  const [maxPrice, setMaxPrice] = useState(initial.maxPrice);
  const [locationState, setLocationState] = useState(initial.locationState);
  const [selectedRegions, setSelectedRegions] = useState(
    initial.selectedRegions,
  );
  const [newListing, setNewListing] = useState(initial.newListing || false);
  const [status, setStatus] = useState(initial.status);

  const search = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setLoading(true);
    window.location.assign(
      listingSearchURL({
        selectedSuburbs,
        keywords,
        minPrice,
        maxPrice,
        selectedCategories,
        locationState,
        selectedRegions,
        newListing,
        status,
      }),
    );
  };

  return {
    loading,
    selectedSuburbs,
    setSelectedSuburbs,
    selectedCategories,
    setSelectedCategories,
    keywords,
    setKeywords,
    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice,
    locationState,
    setLocationState,
    selectedRegions,
    setSelectedRegions,
    newListing,
    setNewListing,
    status,
    setStatus,
    search,
  };
};
